import classNames from "classnames";

function Emoji5({ selected = false, onClick }) {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer group"
      onClick={onClick}
    >
      <g clipPath="url(#clip0_16442_1274)">
        <path
          d="M28.6222 46.8646C40.0116 46.8646 49.2445 37.6774 49.2445 26.3444C49.2445 15.0114 40.0116 5.82422 28.6222 5.82422C17.2329 5.82422 8 15.0114 8 26.3444C8 37.6774 17.2329 46.8646 28.6222 46.8646Z"
          className={classNames(
            "group-hover:fill-[#FFCC80]",
            selected ? "fill-[#FFCC80]" : "fill-[#E2E2E2]"
          )}
        />
        <g filter="url(#filter0_d_16442_1274)">
          <path
            d="M28.6222 46.8646C40.0116 46.8646 49.2445 37.6774 49.2445 26.3444C49.2445 15.0114 40.0116 5.82422 28.6222 5.82422C17.2329 5.82422 8 15.0114 8 26.3444C8 37.6774 17.2329 46.8646 28.6222 46.8646Z"
            stroke="white"
            strokeWidth="5"
            strokeMiterlimit="10"
            shapeRendering="crispEdges"
          />
        </g>
        <path
          d="M35.9561 30.1387C35.9561 32.5397 34.7871 34.6702 32.9858 36.0025C31.7692 36.8953 30.2602 37.4296 28.6289 37.4296C26.9976 37.4296 25.4819 36.8953 24.2652 36.0025C22.464 34.6702 21.2949 32.5397 21.2949 30.1387H35.9561Z"
          className={classNames(
            "group-hover:fill-[#1E1E1E]",
            selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
          )}
        />
        <path
          opacity="0.77"
          d="M32.9857 36.0015C31.7691 36.8943 30.2601 37.4286 28.6288 37.4286C26.9975 37.4286 25.4818 36.8943 24.2651 36.0015C24.8633 34.1754 26.5897 32.8633 28.6288 32.8633C30.668 32.8633 32.3876 34.1754 32.9857 36.0015Z"
          className={classNames(
            "group-hover:fill-[#ED5F5F]",
            selected ? "fill-[#ED5F5F]" : "fill-[#E2E2E2]"
          )}
        />
        <path
          d="M25.5632 21.2041L21.6277 25.1201L17.6923 21.2041C17.3048 20.7983 17.0737 20.2505 17.0737 19.6486C17.0737 18.3973 18.0933 17.3828 19.3507 17.3828C19.9557 17.3828 20.4994 17.6128 20.9073 17.9983C21.3491 18.4108 21.6277 18.9925 21.6277 19.6486C21.6277 18.9993 21.9064 18.4108 22.3482 17.9983C22.7561 17.6128 23.2998 17.3828 23.9048 17.3828C25.1622 17.3828 26.1818 18.3973 26.1818 19.6486C26.1818 20.2505 25.9507 20.7916 25.5632 21.1974V21.2041Z"
          className={classNames(
            "group-hover:fill-[#ED5F5F]",
            selected ? "fill-[#ED5F5F]" : "fill-[#666666]"
          )}
        />
        <path
          d="M38.9944 21.2041L35.0589 25.1201L31.1234 21.2041C30.736 20.7983 30.5049 20.2505 30.5049 19.6486C30.5049 18.3973 31.5244 17.3828 32.7819 17.3828C33.3868 17.3828 33.9306 17.6128 34.3384 17.9983C34.7802 18.4108 35.0589 18.9925 35.0589 19.6486C35.0589 18.9993 35.3376 18.4108 35.7794 17.9983C36.1872 17.6128 36.731 17.3828 37.3359 17.3828C38.5934 17.3828 39.6129 18.3973 39.6129 19.6486C39.6129 20.2505 39.3818 20.7916 38.9944 21.1974V21.2041Z"
          className={classNames(
            "group-hover:fill-[#ED5F5F]",
            selected ? "fill-[#ED5F5F]" : "fill-[#666666]"
          )}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_16442_1274"
          x="1.5"
          y="-0.675781"
          width="54.2446"
          height="54.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16442_1274"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16442_1274"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_16442_1274">
          <rect width="57" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Emoji5;
